module.exports = __webpack_public_path__ + "assets/scorestream-white-full-bab29ff99265bce6781ea4bffc2c0d0e.png";